/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type PdpRespSidebarButtons_displayInfo$ref: FragmentReference;
export type PdpRespSidebarButtons_displayInfo = {|
  +ctas: ?{|
    +showPurchase: ?boolean,
    +showMakeOffer: ?boolean,
    +showRequestPrice: ?boolean,
    +showRequestSourcing: ?boolean,
    +showFollowCategory: ?boolean,
    +showAcceptOffer: ?boolean,
  |},
  +$refType: PdpRespSidebarButtons_displayInfo$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "PdpRespSidebarButtons_displayInfo",
  "type": "ItemDisplayInfo",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "ctas",
      "storageKey": null,
      "args": null,
      "concreteType": "CTADisplay",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showPurchase",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showMakeOffer",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showRequestPrice",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showRequestSourcing",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showFollowCategory",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "showAcceptOffer",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'c1ac71653604603c677cf46b8d349be7';
module.exports = node;
